import React from 'react'

export const AuthLayout = ({
    heading,
    title,
    children,
    footer,
}) => {
    return (
        <section className="auth_section">
            <div className='card_form_wrapper'>
                <div className='auth_heading'>
                    <img src="/images/logo-fill.png" alt="" />
                    <h1>{heading}</h1>
                    <p>{title}</p>


                </div>
                <hr className='line-seperator' />
                <div className='auth-content'>

                {children}
                </div>

                {/* {footer} */}
            </div>
        </section>
    )
}
